import i18n from "utils/i18n";
import _ from 'lodash'

const HelperArray = {
	/**
	 *
	 * @param list
	 * @returns {string|*}
	 */
	naturalJoin: ( list ) => {
		const conjunction = i18n.t('basic.and' );
		
		// Copy otherwise we change the original array
		list = _.uniq( [ ...list ] )
		
		const last = list.pop();
		if( list.length > 0 ) {
			return list.join(', ') +' '+ conjunction +' '+ last;
		}
		
		return last;
	},
	
	shuffleWithSeed: (array, seed) => {                // <-- ADDED ARGUMENT
		let m = array.length, t, i;
		
		// While there remain elements to shuffle…
		while (m) {
			
			// Pick a remaining element…
			i = Math.floor(HelperArray.randomWithSeed(seed) * m--);        // <-- MODIFIED LINE
			
			// And swap it with the current element.
			t = array[m];
			array[m] = array[i];
			array[i] = t;
			++seed                                     // <-- ADDED LINE
		}
		
		return array;
	},
	
	randomWithSeed: (seed) => {
		const x = Math.sin(seed++) * 10000;
		return x - Math.floor(x);
	}
}

export default HelperArray
